// extracted by mini-css-extract-plugin
export default {"ScoreCard":"ScoreCard-module__ScoreCard--p_Qa4","completed":"ScoreCard-module__completed--mTjhJ","text":"ScoreCard-module__text--Wh3h5"};